import { printReceipt } from './wrapperClient';
const stringToColor = (string) => {
  let hash = 0;
  let i;
  for (i = 0; i < string?.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
};

export const getReactEnvSafe = () => {
  if (typeof process !== "undefined" && process.env) {
    return process.env;
  }

  return {};
};

const utils = {
  // function to format id
  format: (num) => {
    return String(num).padStart(5, "0");
  },

  // function to format price
  round: (number) => {
    const value = Number(number);
    return Math.sign(value) * Math.round((Math.abs(value) + Number.EPSILON) * 100) / 100;
  },

  // token header
  tokenHeader: (token) => {
    return {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Authorization: `Bearer ${token}`,
      },
    };
  },

  header: () => {
    return {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
      },
    };
  },

  parameters: [
    {
      include: [
        {
          relation: "hasCurrency"
        }
      ]
    },
    {
      include: [
        {
          relation: "hasCategories",
          scope: {
            include: [
              {
                relation: "hasItems",
                scope: {
                  include: [
                    {
                      relation: "hasOptions"
                    }
                  ]
                }
              }
            ]
          }
        }
      ]
    },
    {
      include: [
        {
          relation: "hasInvoices",
        }
      ]
    },
    {
      include: [
        {
          relation: "hasDesignation",
        }
      ]
    },
    {
      include: [
        {
          relation: "hasEvents",
        }
      ]
    },
    {
      include: [
        {
          relation: "hasExpenses",
          scope: {
            include: [
              {
                relation: "hasExpenseType",
              }
            ]
          }
        }
      ]
    },
    {
      include: [
        {
          relation: "hasExpenseType",
        }
      ]
    }
  ],

  stringAvatar: (name) => {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name?.split(' ')[0][0]}`.toUpperCase(),
    };
  },

  stringToColor: (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = hash % 360;
    return `hsl(${hue}, 70%, 50%)`; // bright enough for text
  },

  /*getKey: (obj, valueToFind) => (
    Object.entries(obj).find(([_, value]) => value.toLowerCase() === valueToFind.toLowerCase())?.[0]
  ),*/

  addFieldAtPosition: (obj, key, value, position) => {
    const entries = Object.entries(obj);
    entries.splice(position, 0, [key, value]);
    return Object.fromEntries(entries);
  },

  isEmpty: (value) => {
    return (
      value === null || value === undefined ||
      (typeof value === 'string' && value.trim() === '') ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'object' && Object.keys(value).length === 0)
    );
  },

  calculateTotalAmount: (invoices) => {
    return invoices.reduce(
      (sum, invoice) => sum + (Number(invoice.totalAmount) || 0),
      0
    );
  },

  /**
   * Envoie un ticket via le client partagé du wrapper Android.
   * Les composants conservent leur propre impression navigateur.
   */
  printReceipt,

  capitalizeFirst: (text) => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  },

  shortHashToNumber: (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash * 31 + str.charCodeAt(i)) % 1000000; // Keep it within 6 digits
    }
    return hash;
  },

  formatItemName: (name) => {
  const match = name.match(/^\[(.+?)\]\s*(.+)$/);
  return match ? `${match[2]} [${match[1]}]` : name;
},

  // "Frais de déplacement" is a manually-added administrative fee (see
  // handleDeplacement in pos2.jsx), not a real prestation/product — it has no
  // categoryName, so it can only be recognized by its stored itemName. Invoices
  // may hold either translation depending on the cashier's UI language at the
  // time of sale, so both must be matched regardless of the current locale.
  isDeplacementFeeItem: (itemName) => {
    const normalized = String(itemName || "").trim().toLowerCase();
    return normalized === "frais de déplacement" || normalized === "deplacement fee";
  },
};

export default utils;
